import {useEffect} from 'react'
import {
  Image,
  Text,
  Link,
  VStack,
  Button,
  CloseIcon
} from "native-base";
import StyledButton from '../../../components/Button/index'
import { useNavigate } from "react-router-dom";
import useScrollToTop from '../../../hooks/useScrollToTop'

function UpcycleANS() {
  const scrollToTop = useScrollToTop();

  var endImage = require('../../../images/dressOneEndLife.png');
  const navigate = useNavigate();

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);
  return (
    <>
        <VStack alignItems="flex-start" space={0} px={"4"} paddingTop={'4'}>
        <Button onPress={() => navigate(-1)} variant={'unstyled'}><CloseIcon color={'#1341B6'} size={"5"}/></Button>
        </VStack>
        <VStack alignItems={"center"} px={4} space={0}>
          <Text color={"#1341B6"} fontSize={"4xl"} fontFamily={'heading'}>Upcycle</Text>
        </VStack>
        <VStack alignItems={"center"} marginBottom={"4"} px={4} space={18} marginTop={'24px'}>
        <Text color={"#1341B6"} fontSize={'12px'} fontWeight={'300'}>To reduce the waste that comes from textiles, we don't let any fabric piece go to waste.</Text>
          <Text color={"#1341B6"} fontSize={'12px'}  fontWeight={'300'}>If your dress is beyond repair or cannot be resold, send it back to us so we can upcycle the fabric pieces into something new.</Text>
        </VStack>
        <VStack alignItems={"center"} px={4} py={2}>  
        <Link href="https://tilli.fr/reserver-votre-couturier-a-domicile/" width={'full'}>
               <StyledButton
              text={'Get your shipping label'}
              backgroundColor={'#1341B6'}
             textColor="#FFFFFF"
            borderColor="transparent"
            width="100%"
            height="54px"
           hoverBackgroundColor="#FFFFFF"
           hoverTextColor={'#1341B6'}
           hoverBorderColor={'#1341B6'}
          />
          </Link>
          {/* <Button width="full" borderColor="#1341B6" marginBottom={4}>
          Get your shipping label
        </Button> */}
        </VStack>
        <VStack alignItems={'center'} marginTop={'24px'}>
        <Image
              source={{ uri: endImage }}
              alt="Alternate Text"
              size="xl"
              width="full"
              height="535px"
          />
        </VStack>

        </>
  );
}

export default UpcycleANS;
